import { HTMLAttributes } from 'react';

import { FlexBoxDiv, IFlexBoxDiv } from './styled';

export interface IFlexBox extends HTMLAttributes<HTMLDivElement>, IFlexBoxDiv {
  children: React.ReactNode;
}

export function FlexBox(args: IFlexBox) {
  return <FlexBoxDiv {...args}>{args.children}</FlexBoxDiv>;
}
